import { CMS_PREFIX_LIST } from "./cmsPrefix";
import { mapToCopyFileShared } from "./mapToCopyFileShared";

const {
  navigation,
  home,
  myTasks,
  sessionReview,
  entryScreen,
  institution,
  patientManagement,
  roles,
  settings,
  treatments,
} = CMS_PREFIX_LIST["portal"];

/* eslint-disable */
const mapToCopyFilePortal = (copy: Record<string, string>) => {
  const getCopyValue = (key: string) => copy?.[key] ?? "";

  const sharedStories = mapToCopyFileShared(copy);

  return {
    errorFallback: {
      errorTitle: "There was an error.",
      dialog: {
        title: "It looks like we are having some internal issues.",
        description: "Our Team has been notified.",
        reloadButton: "Reload page",
      },
      toast: {
        title: "There was an error.",
        description: "It looks like we are having some internal issues. Our Team has been notified.",
        unhandledError: "Unhandled Error",
      },
    },
    shared: {
      // @ TODO move this at top when all stories will be moved to shared.
      ...sharedStories.shared,
      specialities: {
        "sports-physiotherapy": getCopyValue("portal/specialities/sports-physiotherapy"),
        "general-physiotherapy": getCopyValue("portal/specialities/general-physiotherapy"),
        "pelvic-floor": getCopyValue("portal/specialities/pelvic-floor"),
        pediatrics: getCopyValue("portal/specialities/pediatrics"),
        "neuromotor-and-sensory": getCopyValue("portal/specialities/neuromotor-and-sensory"),
        "internal-organs-and-vessels": getCopyValue("portal/specialities/internal-organs-and-vessels"),
        musculoskeletal: getCopyValue("portal/specialities/musculoskeletal"),
        "virtual-therapist": getCopyValue("portal/specialities/virtual-therapist"),
        geriatric: getCopyValue("portal/specialities/geriatric"),
      },
      roles: {
        therapist: getCopyValue(`${institution}/invite-new-team-member/physiotherapist/main-text`),
        manager_scheduler: getCopyValue(`${institution}/invite-new-team-member/scheduler/main-text`),
        manager_admin: getCopyValue(`${institution}/invite-new-team-member/admin/main-text`),
        newPatientOrMemberButton: getCopyValue(`${roles}/new-patient-or-member`),
        newMemberButton: getCopyValue(`${roles}/new-member`),
        newPatientButton: getCopyValue(`${roles}/new-patient`),
      },
      gender: {
        male: getCopyValue("portal/gender/male"),
        female: getCopyValue("portal/gender/female"),
      },
      difficulties: {
        exerciseReview: {
          easy: getCopyValue("portal/difficulty/exercise-review-difficulty/easy"),
          medium: getCopyValue("portal/difficulty/exercise-review-difficulty/medium"),
          hard: getCopyValue("portal/difficulty/exercise-review-difficulty/hard"),
        },
      },
      phases: {
        justConnected: getCopyValue("portal/session-review/phases-tags/just-connected"),
        beginning: getCopyValue("portal/session-review/phases-tags/beginning"),
        core: getCopyValue("portal/session-review/phases-tags/core"),
        ending: getCopyValue("portal/session-review/phases-tags/ending"),
      },
      search: {
        noResultsTitle: getCopyValue("portal/search/no-results-found/title"),
        noResultsMessage: getCopyValue("portal/search/no-results-found/sub-text"),
      },
      udiNumber: getCopyValue(`${settings}/udi-and-ce-mark/udi-number`),
    },
    legalPage: {
      download: getCopyValue(`care/profile-and-settings/settings/medical-information/download`),
      tableOfContentsHeadline: getCopyValue(`${settings}/legal-pages/table-of-contents-headline`),
      tableOfContentsMultipleLanguages: {
        en: getCopyValue(`${settings}/legal-pages/table-of-contents-headline-en`),
        de: getCopyValue(`${settings}/legal-pages/table-of-contents-headline-de`),
        fr: getCopyValue(`${settings}/legal-pages/table-of-contents-headline-fr`),
        it: getCopyValue(`${settings}/legal-pages/table-of-contents-headline-it`),
      },
      version: "Version {versionNumber}",
    },
    navigation: {
      search: getCopyValue(`${navigation}/search`),
      notifications: getCopyValue(`${navigation}/notifications`),
      home: getCopyValue(`${navigation}/home`),
      workspace: getCopyValue(`${navigation}/workspace`),
      myTasks: getCopyValue(`${navigation}/my-tasks`),
      patients: getCopyValue(`${navigation}/patients`),
      support: getCopyValue(`${navigation}/support`),
      supportEmail: getCopyValue(`${navigation}/support-email`),
      institution: getCopyValue(`${navigation}/institution`),
      profile: getCopyValue(`${navigation}/profile`),
      settings: getCopyValue(`${navigation}/settings`),
      logout: getCopyValue(`${navigation}/log-out`),
      instructionsForUse: getCopyValue(`${navigation}/instructions-for-use`),
      appName: getCopyValue(`${navigation}/app-name`),
      treatments: getCopyValue(`${navigation}/treatments`),
    },
    fileUpload: {
      toasters: {
        fileTypeNotSupported: getCopyValue(
          "portal/profile/institution-profile-page/update-institution-profile-details/toaster-filetype-error",
        ),
        fileSizeExceeded: getCopyValue(
          "portal/profile/institution-profile-page/update-institution-profile-details/toaster-filesize",
        ),
        uploadFailed: getCopyValue(
          "portal/profile/institution-profile-page/update-institution-profile-details/toaster-uploadfailed",
        ),
      },
    },
    institution: {
      edit: {
        title: getCopyValue(`${institution}/update-institution-profile-details/title`),
        save: getCopyValue(`${institution}/update-institution-profile-details/update`),
        successToaster: getCopyValue(
          "portal/profile/institution-profile-page/update-institution-profile-details/toaster-successfullupdate",
        ),
        gallery: {
          title: getCopyValue(`${institution}/update-institution-profile-details/photo-gallery/title`),
          subtitle: getCopyValue(`${institution}/update-institution-profile-details/photo-gallery/sub-text`),
        },
        profilePicture: {
          title: getCopyValue(`${institution}/update-institution-profile-details/profile-picture/title`),
          subtitle: getCopyValue(`${institution}/update-institution-profile-details/profile-picture/sub-text`),
        },
        name: {
          label: getCopyValue(`${institution}/update-institution-profile-details/institution`),
          placeholder: getCopyValue(`${institution}/update-institution-profile-details/institution`),
        },
        specialties: {
          label: getCopyValue(`${institution}/update-institution-profile-details/specialities/box-title`),
          placeholder: getCopyValue(`${institution}/update-institution-profile-details/specialities/content-example`),
        },
        address: {
          label: getCopyValue(`${institution}/update-institution-profile-details/location/box-title`),
          placeholder: getCopyValue(`${institution}/update-institution-profile-details/location/content-example`),
        },
        websiteUrl: {
          label: getCopyValue(`${institution}/update-institution-profile-details/website/box-title`),
          placeholder: getCopyValue(`${institution}/update-institution-profile-details/website/content-example`),
        },
        phoneNumber: {
          label: getCopyValue(`${institution}/update-institution-profile-details/phone-number/box-title`),
          placeholder: getCopyValue(`${institution}/update-institution-profile-details/phone-number/content-example`),
        },
      },
      title: getCopyValue(`${institution}/institution`),
      teamMemberDetails: {
        deleteTeamMember: getCopyValue(`${institution}/team-member-details/delete-team-member`),
        editTeamMember: getCopyValue(`${institution}/team-member-details/edit-team-member`),
        patients: getCopyValue(`${institution}/team-member-details/patients`),
        modal: {
          question: getCopyValue(`${institution}/delete-team-member/question`),
          cancelButton: getCopyValue(`${institution}/delete-team-member/cancel`),
          deleteButton: getCopyValue(`${institution}/delete-team-member/delete`),
          details: getCopyValue(`${institution}/delete-team-member/details`),
          title: getCopyValue(`${institution}/delete-team-member/title`),
          deleteOneselfWarning: getCopyValue(`${institution}/delete-team-member/delete-oneself-warning`),
          deleteTherapistWarning: getCopyValue(`${institution}/delete-team-member/delete-therapist-warning`),
          deleteSuccess: getCopyValue(`${institution}/delete-team-member/delete-success`),
          deleteError: getCopyValue(`${institution}/delete-team-member/delete-error`),
        },
        lastActiveLabel: getCopyValue(`${institution}/team-member-details/last-active-label`),
      },
      assignPTModal: {
        successToast: getCopyValue(`${institution}/assign-pt-to-patient/success-toast`),
        headline: getCopyValue(`${institution}/assign-pt-to-patient/title`),
        assignButton: getCopyValue(`${institution}/assign-pt-to-patient/assign`),
        filterButton: getCopyValue(`${institution}/assign-pt-to-patient/filter`),
        sortButton: getCopyValue(`${institution}/assign-pt-to-patient/sort`),
        physiotherapistsField: getCopyValue(`${institution}/assign-pt-to-patient/physiotherapists`),
        patientLabel: getCopyValue(`${institution}/assign-pt-to-patient/patient`),
        noPatientsField: getCopyValue(`${institution}/assign-pt-to-patient/patients`),
        searchBarPlaceholder: getCopyValue(`${institution}/assign-pt-to-patient/tablesearchbar/content-example`),
        noPTSelectedError: getCopyValue(`${institution}/assign-pt-to-patient/no-pt-selected`),
      },
      patientsTable: {
        assignPTButton: getCopyValue(`${institution}/table/assign-pt`),
      },
      profile: {
        allPatientsLabel: getCopyValue(`${institution}/table/table-labels/all-patients`),
        requestedDateLabel: getCopyValue(`${institution}/table/table-labels/requested-date`),
        diagnosisLabel: getCopyValue(`${institution}/table/table-labels/diagnosis`),
        teamMembersLabel: getCopyValue(`${institution}/table/table-labels/team-members`),
        patientLabel: getCopyValue(`${institution}/table/table-labels/patient`),
        memberLabel: getCopyValue(`${institution}/table/table-labels/member`),
        patientsLabel: getCopyValue(`${institution}/table/table-labels/patients`),
        roleLabel: getCopyValue(`${institution}/table/table-labels/role`),
        lastActiveLabel: getCopyValue(`${institution}/table/table-labels/last-active`),
        searchBarPlaceholderPatient: getCopyValue(`${institution}/table/tablesearchbar/content-example`),
        searchBarPlaceholderTherapist: getCopyValue(`portal/patient-management/search-pt/content-example`),
        filterLabel: getCopyValue(`${institution}/table/filter`),
        viewPrescription: getCopyValue(`${institution}/table/view-prescription`),
        assignPT: getCopyValue(`${institution}/table/assign-pt`),
        sort: {
          ascending: getCopyValue(`${institution}/table/sort-by/ascending`),
          descending: getCopyValue(`${institution}/table/sort-by/descending`),
          sortBy: getCopyValue(`${institution}/table/sort-by/sort-by`),
          order: getCopyValue(`${institution}/table/sort-by/order`),
          sortLabel: getCopyValue(`${institution}/table/sort`),
          options: {
            name: getCopyValue(`${institution}/table/sort-by/alphabetical`),
            diagnosis: getCopyValue(`${institution}/table/table-labels/diagnosis`),
            therapyPhase: getCopyValue(`${patientManagement}/list-labels/therapy-phase`),
            requestedDate: getCopyValue(`${institution}/table/table-labels/requested-date`),
            role: getCopyValue(`${institution}/table/table-labels/role`),
            noPatients: getCopyValue(`${institution}/table/table-labels/patients`),
            lastActive: getCopyValue(`${institution}/table/table-labels/last-active`),
            therapyPlan: getCopyValue(`${institution}/table/table-labels/therapy-plan`),
            therapyProgress: getCopyValue(`${institution}/table/table-labels/therapy-progress`),
          },
        },
        filterModal: {
          applyButton: getCopyValue(`${institution}/table/filter-module/apply`),
          clearButton: getCopyValue(`${institution}/table/filter-module/clear-filters`),
          title: getCopyValue(`${institution}/table/filter-module/filter`),
        },
        activeFilters: {
          resetButton: getCopyValue(`${institution}/table/active-filters/reset`),
        },
        requestsEmptyState: {
          noResultsTitle: getCopyValue(`${institution}/requests-empty-state/no-results-found`),
          noResultsMessage: getCopyValue(`${institution}/requests-empty-state/no-results-message`),
          noDataTitle: getCopyValue(`${institution}/requests-empty-state/no-data-title`),
          noDataMessage: getCopyValue(`${institution}/requests-empty-state/no-data-message`),
        },
        teamMembersEmptyState: {
          noResultsTitle: getCopyValue(`${institution}/team-member-empty-state/no-results-found-title`),
          noResultsMessage: getCopyValue(`${institution}/team-member-empty-state/no-results-found-message`),
          noTeamMembersTitle: getCopyValue(`${institution}/team-member-empty-state/no-team-members-title`),
          noTeamMembersMessage: getCopyValue(`${institution}/team-member-empty-state/no-team-members-message`),
        },
      },

      editRoleModal: {
        confirmButton: getCopyValue(`${institution}/edit-role/confirm`),
        cancelButton: getCopyValue(`${institution}/edit-role/cancel`),
        editRoleTitle: getCopyValue(`${institution}/edit-role/edit-role`),
        roleLabel: getCopyValue(`${institution}/edit-role/role`),
        details: getCopyValue(`${institution}/edit-role/details`),
        cantEditRole: getCopyValue(`${institution}/edit-role/cant-edit-role`),
        successToast: getCopyValue(`${institution}/edit-role/success-toast`),
      },
    },
    treatmentTemplates: {
      hip: getCopyValue(`${patientManagement}/treatment-templates/body-parts-hip`),
      back: getCopyValue(`${patientManagement}/treatment-templates/body-parts-back`),
    },
    home: {
      greeting: getCopyValue(`${home}/greet-and-continue-review/greetings-pool/hello`),
      invitePatientCta: getCopyValue(`${home}/invite-patient-cta`),
      seeListCta: getCopyValue(`${home}/see-list-cta`),
      kpiOnboarding: getCopyValue(`${home}/kpi-onboarding`),
      kpiActive: getCopyValue(`${home}/kpi-active`),
      kpiInactive: getCopyValue(`${home}/kpi-inactive`),
      kpiEnding: getCopyValue(`${home}/kpi-ending`),
      continueReviewButton: getCopyValue(`${home}/greet-and-continue-review/continue-review`),
      browserIssuesBanner: {
        unsupportedBrowser: {
          headline: getCopyValue(`${home}/browser-issues-banner/unsupported-browser/title`),
          description: getCopyValue(`${home}/browser-issues-banner/unsupported-browser/description`),
          button: getCopyValue(`${home}/browser-issues-banner/unsupported-browser/button`),
        },
        outdatedBrowser: {
          headline: getCopyValue(`${home}/browser-issues-banner/outdated-browser/title`),
          description: getCopyValue(`${home}/browser-issues-banner/outdated-browser/description`),
          button: getCopyValue(`${home}/browser-issues-banner/outdated-browser/button`),
        },
      },
      newPatient: getCopyValue(`${home}/quick-actions/new-patient`),
      organizationInsight: {
        patients_with_streak: getCopyValue(`${home}/organization-insight/patients_with_streak`),
        good_session_ratings: getCopyValue(`${home}/organization-insight/good_session_ratings`),
        patients_rating_good: getCopyValue(`${home}/organization-insight/patients_rating_good`),
        new_invited_patients: getCopyValue(`${home}/organization-insight/new_invited_patients`),
        new_patients_started_training: getCopyValue(`${home}/organization-insight/new_patients_started_training`),
        active_patients: getCopyValue(`${home}/organization-insight/active_patients`),
        active_patient_increase_post_first_month: getCopyValue(
          `${home}/organization-insight/active_patient_increase_post_first_month`,
        ),
        training_session_ratings_improved: getCopyValue(
          `${home}/organization-insight/training_session_ratings_improved`,
        ),
        training_sessions_completed: getCopyValue(`${home}/organization-insight/training_sessions_completed`),
        active_pts: getCopyValue(`${home}/organization-insight/active_pts`),
      },
      successSpotlightHeadline: getCopyValue(`${home}/success-spotlight-headline`),
      inviteNewPatientPage: {
        headline: getCopyValue("portal/patient-management/invite-new-patient-page/invite-new-patient"),
        sections: {
          patientDetails: {
            title: getCopyValue("portal/patient-management/invite-new-patient-page/patient-details-title"),
          },
          treatmentSetup: {
            title: getCopyValue("portal/patient-management/invite-new-patient-page/treatment-setup-title"),
          },
          coverageSelection: {
            title: getCopyValue("portal/patient-management/invite-new-patient-page/coverage-selection-title"),
            question: getCopyValue("portal/patient-management/invite-new-patient-page/coverage-selection-question"),
            selfPayer: getCopyValue("portal/patient-management/invite-new-patient-page/coverage-selection-self-payer"),
            insurance: getCopyValue("portal/patient-management/invite-new-patient-page/coverage-selection-insurance"),
            selfPayerInfo: getCopyValue(
              "portal/patient-management/invite-new-patient-page/coverage-selection-self-payer-info",
            ),
            insuranceInfo: getCopyValue(
              "portal/patient-management/invite-new-patient-page/coverage-selection-insurance-info",
            ),
            insuranceDisabledTooltip: getCopyValue(
              "portal/patient-management/invite-new-patient-page/insurance-disabled-tooltip",
            ),
          },
        },
        formFields: {
          firstName: {
            label: getCopyValue("portal/patient-management/invite-new-patient-page/first-name/box-title"),
            placeholder: getCopyValue("portal/patient-management/invite-new-patient-page/first-name/content-example"),
          },
          lastName: {
            label: getCopyValue("portal/patient-management/invite-new-patient-page/last-name/box-title"),
            placeholder: getCopyValue("portal/patient-management/invite-new-patient-page/last-name/content-example"),
          },
          email: {
            label: getCopyValue("portal/patient-management/invite-new-patient-page/email/box-title"),
            placeholder: getCopyValue("portal/patient-management/invite-new-patient-page/email/content-example"),
          },
          dateOfBirth: {
            label: getCopyValue("portal/patient-management/invite-new-patient-page/date-of-birth-label"),
            placeholder: getCopyValue("portal/patient-management/invite-new-patient-page/date-input-placeholder"),
            ageBoundariesError: getCopyValue("portal/patient-management/invite-new-patient-page/error-age-boundaries"),
            invalidDateError: getCopyValue("portal/patient-management/invite-new-patient-page/error-invalid-date"),
            calendarSearchPlaceholder: getCopyValue(
              "portal/patient-management/invite-new-patient-page/calendar-search-placeholder",
            ),
          },
          language: {
            label: getCopyValue("portal/patient-management/invite-new-patient-page/patient-language/title"),
            placeholder: getCopyValue("portal/patient-management/invite-new-patient-page/patient-language/sub-text"),
          },
          physiotherapist: {
            label: getCopyValue("portal/patient-management/invite-new-patient-page/physiotherapist/title"),
            placeholder: getCopyValue("portal/patient-management/invite-new-patient-page/physiotherapist/sub-text"),
            numberOfPatients: getCopyValue("portal/patient-management/invite-new-patient-page/number-of-patients"),
          },
          therapyPlan: {
            label: getCopyValue("portal/patient-management/invite-new-patient-page/therapy-plan/title"),
            placeholder: getCopyValue("portal/patient-management/invite-new-patient-page/therapy-plan/sub-text"),
          },
          bodyPart: {
            label: getCopyValue("portal/patient-management/invite-new-patient-page/body-part-label"),
          },
          personalization: {
            label: getCopyValue("portal/patient-management/invite-new-patient-page/personalization-label"),
            tooltip: getCopyValue("portal/patient-management/invite-new-patient-page/personalization-tooltip"),
            disabledTooltip: getCopyValue(
              "portal/patient-management/invite-new-patient-page/personalization-tooltip-disabled-state",
            ),
            placeholder: getCopyValue("portal/patient-management/invite-new-patient-page/personalization-placeholder"),
          },
          errors: {
            requiredError: getCopyValue("portal/patient-management/invite-new-patient-page/required-error"),
            firstNameRequired: getCopyValue(
              "portal/patient-management/invite-new-patient-page/error-first-name-required",
            ),
            lastNameRequired: getCopyValue(
              "portal/patient-management/invite-new-patient-page/error-last-name-required",
            ),
            emailRequired: getCopyValue("portal/patient-management/invite-new-patient-page/error-email-required"),
            invalidEmailError: getCopyValue(
              "portal/patient-management/invite-new-patient-page/invalid-email-address-error",
            ),
            emailAlreadyExistsError: getCopyValue(
              "portal/patient-management/invite-new-patient-page/email-already-exists-error",
            ),
            dateOfBirthRequired: getCopyValue(
              "portal/patient-management/invite-new-patient-page/error-date-of-birth-required",
            ),
            bodyPartRequired: getCopyValue(
              "portal/patient-management/invite-new-patient-page/error-body-part-required",
            ),
            patientLanguageRequired: getCopyValue(
              "portal/patient-management/invite-new-patient-page/error-patient-language-required",
            ),
            physiotherapistRequired: getCopyValue(
              "portal/patient-management/invite-new-patient-page/error-physhiotherapist-required",
            ),
            therapyPlanRequired: getCopyValue(
              "portal/patient-management/invite-new-patient-page/error-therapy-plan-required",
            ),
          },
        },
        submitButton: getCopyValue("portal/patient-management/invite-new-patient-page/invite"),
        toasters: {
          patientInvitedSuccessfully: getCopyValue(
            "portal/profile/institution-profile-page/update-institution-profile-details/toaster-patient-invited-successfully",
          ),
          patientInvitedError: getCopyValue(
            "portal/profile/institution-profile-page/update-institution-profile-details/toaster-patient-invited-error",
          ),
        },
      },
      newMember: getCopyValue(`${home}/quick-actions/new-member`),
      inviteNewMemberModal: {
        headline: getCopyValue(`${institution}/invite-new-team-member/title`),
        description: getCopyValue(`${institution}/invite-new-team-member/details`),
        firstNameLabel: getCopyValue(`${institution}/invite-new-team-member/first-name/box-title`),
        firstNamePlaceholder: getCopyValue(`${institution}/invite-new-team-member/first-name/content-example`),
        lastNameLabel: getCopyValue(`${institution}/invite-new-team-member/last-name/box-title`),
        lastNamePlaceholder: getCopyValue(`${institution}/invite-new-team-member/last-name/content-example`),
        emailLabel: getCopyValue(`${institution}/invite-new-team-member/email/box-title`),
        emailPlaceholder: getCopyValue(`${institution}/invite-new-team-member/email/content-example`),
        roleLabel: getCopyValue(`${institution}/invite-new-team-member/role`),
        physiotherapistOption: getCopyValue(`${institution}/invite-new-team-member/physiotherapist/main-text`),
        physiotherapistTooltipText: getCopyValue(`${institution}/invite-new-team-member/physiotherapist/tooltip-text`),
        schedulerOption: getCopyValue(`${institution}/invite-new-team-member/scheduler/main-text`),
        schedulerTooltipText: getCopyValue(`${institution}/invite-new-team-member/scheduler/tooltip-text`),
        adminOption: getCopyValue(`${institution}/invite-new-team-member/admin/main-text`),
        adminTooltipText: getCopyValue(`${institution}/invite-new-team-member/admin/tooltip-text`),
        inviteButton: getCopyValue(`${institution}/invite-new-team-member/invite`),
        cancelButton: getCopyValue(`${institution}/invite-new-team-member/cancel`),
        requiredError: getCopyValue(`${institution}/invite-new-team-member/required-error`),
        invalidEmailError: getCopyValue(`${institution}/invite-new-team-member/invalid-email-address-error`),
        inviteSuccess: getCopyValue(`${institution}/invite-new-team-member/success`),
      },
      aboutAkina: getCopyValue(`${home}/tips-articles/about-akina`),
      learnMore: getCopyValue(`${home}/tips-articles/learn-more`),
      seeAllTips: getCopyValue(`${home}/tips-articles/see-all`),
      resources: {
        image1: getCopyValue(`${home}/tips-articles/thumbnail-1`),
        image2: getCopyValue(`${home}/tips-articles/thumbnail-2`),
        image3: getCopyValue(`${home}/tips-articles/thumbnail-3`),
        url1: getCopyValue(`${home}/tips-articles/url-1`),
        url2: getCopyValue(`${home}/tips-articles/url-2`),
        url3: getCopyValue(`${home}/tips-articles/url-3`),
        urlBalgrist: getCopyValue(`${home}/tips-articles/url-balgrist`),
        title1: getCopyValue(`${home}/tips-articles/title-1`),
        title2: getCopyValue(`${home}/tips-articles/title-2`),
        title3: getCopyValue(`${home}/tips-articles/title-3`),
      },
      taskOverview: getCopyValue(`${home}/task-overview/task-overview`),
      taskOverviewDoneTitle: getCopyValue(`${home}/task-overview/well-done-you-are-up-to-date/title`),
      taskOverviewDoneSubText: getCopyValue(`${home}/task-overview/well-done-you-are-up-to-date/sub-text`),
      seeAllTasks: getCopyValue(`${home}/task-overview/see-all`),
    },
    legalModals: {
      newMemberTerms: {
        title: getCopyValue(`${entryScreen}/t-c-pop-up/new-member-terms/title`),
        description: getCopyValue(`${entryScreen}/t-c-pop-up/new-member-terms/description`),
        error: getCopyValue(`${entryScreen}/t-c-pop-up/new-member-terms/error`),
      },
      acceptTerms: getCopyValue(`${entryScreen}/welcome/user-consent-page/accept-t-c-and-pp`),
      acceptButton: getCopyValue(`${entryScreen}/welcome/user-consent-page/accept-button`),
      optionalDataProcessing: getCopyValue(`${entryScreen}/welcome/user-consent-page/optional-data-processing`),
      mandatoryDataProcessing: getCopyValue(`${entryScreen}/welcome/user-consent-page/mandatory-data-processing`),
      reviewTerms: getCopyValue(`${entryScreen}/welcome/user-consent-page/review-t-c-and-pp`),
      headerTerms: getCopyValue(`${entryScreen}/welcome/user-consent-page/header-data-safety`),
      termsAndPrivacyLabel: getCopyValue(`${entryScreen}/welcome/user-consent-page/accept-t-s-and-pp/i-accept-the`),
      termsAndPrivacyToS: getCopyValue(`${entryScreen}/welcome/user-consent-page/accept-t-s-and-pp/terms-of-service`),
      termsAndPrivacyToSURL: getCopyValue(
        `${entryScreen}/welcome/user-consent-page/accept-t-s-and-pp/terms-of-service-url`,
      ),
      termsAndPrivacyAnd: getCopyValue(`${entryScreen}/welcome/user-consent-page/accept-t-s-and-pp/and`),
      termsAndPrivacyPP: getCopyValue(`${entryScreen}/welcome/user-consent-page/accept-t-s-and-pp/privacy-policy`),
      termsAndPrivacyPPURL: getCopyValue(
        `${entryScreen}/welcome/user-consent-page/accept-t-s-and-pp/privacy-policy-url`,
      ),
      termsAndPrivacyCheckboxLabel: getCopyValue(`${entryScreen}/welcome/user-consent-page/accept-t-c-and-pp/label`),
      acceptTermsError: getCopyValue(`${entryScreen}/welcome/user-consent-page/accept-t-c-error-state`),
      termsAndConditionsUpdateButton: getCopyValue(`${entryScreen}/t-c-pop-up/accept`),
      termsAndConditionsUpdateError: getCopyValue(`${entryScreen}/t-c-pop-up/error`),
      termsAndConditionsUpdateFailedError: getCopyValue(`${entryScreen}/t-c-pop-up/fail-error`),
    },
    happinessFeedback: {
      headline: getCopyValue(`${entryScreen}/happiness-feedback/headline`),
      textAreaPlaceholder: getCopyValue(`${entryScreen}/happiness-feedback/text-area-placeholder`),
    },
    myTasks: {
      topSection: {
        title: getCopyValue(`${myTasks}/continue-review/my-tasks`),
        continueReview: getCopyValue(`${myTasks}/continue-review/continue-review`),
      },
      patientSessions: {
        sessionNumber: getCopyValue(`${myTasks}/patient-s-sessions/session-number`),
        min: getCopyValue(`${myTasks}/patient-s-sessions/min`),
        session: getCopyValue(`${myTasks}/patient-s-sessions/session`),
        date: getCopyValue(`${myTasks}/patient-s-sessions/date`),
        painLevel: getCopyValue(`${myTasks}/patient-s-sessions/pain-level`),
        therapyPhase: getCopyValue(`${myTasks}/patient-s-sessions/therapy-phase`),
        estimatedTimeText: getCopyValue(`${myTasks}/patient-s-sessions/est-time`),
        sessionsLeft: getCopyValue(`${myTasks}/patient-s-sessions/sessions-left`),
        reviewsLeft: getCopyValue(`${myTasks}/patient-s-sessions/reviews-left`),
      },
    },
    sessionReview: {
      goBackButton: getCopyValue(`${sessionReview}/go-back-button`),
      feedbackHistoryDrawer: {
        sessionNumber: getCopyValue(`${sessionReview}/feedback-history-drawer/session-number`),
        sessionWeek: getCopyValue(`${sessionReview}/feedback-history-drawer/session-week`),
        sessionRoutinesLength: getCopyValue(`${sessionReview}/feedback-history-drawer/session-routines-length`),
        insights: {
          title: getCopyValue(`${sessionReview}/feedback-history-drawer/insights/title`),
          movementQuality: getCopyValue(`${sessionReview}/feedback-history-drawer/insights/movement-quality`),
          painLevel: getCopyValue(`${sessionReview}/feedback-history-drawer/insights/pain-level`),
          sessionCompletion: getCopyValue(`${sessionReview}/feedback-history-drawer/insights/session-completion`),
        },
        comments: {
          title: getCopyValue(`${sessionReview}/feedback-history-drawer/comments/title`),
          selfReflection: getCopyValue(`${sessionReview}/feedback-history-drawer/comments/self-reflection`),
          routineTitle: getCopyValue(`${sessionReview}/feedback-history-drawer/comments/routine-title`),
          routineSubtitle: getCopyValue(`${sessionReview}/feedback-history-drawer/comments/routine-subtitle`),
          routineExerciseCompletion: getCopyValue(
            `${sessionReview}/feedback-history-drawer/comments/routine-exercise-completion`,
          ),
          routineCompletion: getCopyValue(`${sessionReview}/feedback-history-drawer/comments/completion`),
          exercise: getCopyValue(`${sessionReview}/feedback-history-drawer/comments/exercise`),
          routineMovementQuality: getCopyValue(
            `${sessionReview}/feedback-history-drawer/comments/routine-movement-quality`,
          ),
          routineMovQuality: getCopyValue(`${sessionReview}/feedback-history-drawer/comments/routine-mov-quality`),
          routinePainLevel: getCopyValue(`${sessionReview}/feedback-history-drawer/comments/routine-pain-level`),
          routineDifficulty: getCopyValue(`${sessionReview}/feedback-history-drawer/comments/routine-difficulty`),
          overallFeedback: getCopyValue(`${sessionReview}/feedback-history-drawer/comments/overall-feedback`),
        },
      },
      goToPatient: getCopyValue(`${sessionReview}/go-to-patient-overview`),
      startRecording: getCopyValue(`${sessionReview}/exercise-review/feedback-popover-module/start-recording`),
      pause: getCopyValue(`${sessionReview}/exercise-review/feedback-popover-module/pause`),
      resume: getCopyValue(`${sessionReview}/exercise-review/feedback-popover-module/resume`),
      blurBackground: getCopyValue(`${sessionReview}/exercise-review/feedback-popover-module/blur-background`),
      video: getCopyValue(`${sessionReview}/exercise-review/feedback-popover-module/settings-dropdown-menu/video`),
      microphone: getCopyValue(
        `${sessionReview}/exercise-review/feedback-popover-module/settings-dropdown-menu/microphone`,
      ),
      finishRecording: getCopyValue(`${sessionReview}/exercise-review/feedback-popover-module/finish-recording`),
      recordInstruction: getCopyValue(`${sessionReview}/exercise-review/feedback-popover-module/press-record-to-start`),
      delete: getCopyValue(`${sessionReview}/exercise-review/overall-feedback/delete`),
      send: getCopyValue(`${sessionReview}/exercise-review/overall-feedback/send`),
      addAudio: getCopyValue(`${sessionReview}/exercise-review/feedback-popover-module/add-audio`),
      addVideo: getCopyValue(`${sessionReview}/exercise-review/feedback-popover-module/add-video`),
      addComment: getCopyValue(`${sessionReview}/exercise-review/feedback-popover-module/add-comment`),
      addCommentTooltipMessage: getCopyValue(
        `${sessionReview}/exercise-review/feedback-popover-module/add-comment-tooltip-message`,
      ),
      update: getCopyValue(`${sessionReview}/exercise-review/feedback-popover-module/update`),
      avatarBar: {
        patients: getCopyValue(`${sessionReview}/avatar-bar/patients`),
      },
      exerciseLevelLabel: getCopyValue(`${sessionReview}/exercise-review/exercise-level-label`),
      changeExerciseLevelButton: getCopyValue(`${sessionReview}/exercise-review/change-exercise-level-button`),
      previousExerciseButton: getCopyValue(`${sessionReview}/exercise-review/previous-exercise-button`),
      nextExerciseButton: getCopyValue(`${sessionReview}/exercise-review/next-exercise-button`),
      sessionOverviewButton: getCopyValue(`${sessionReview}/exercise-review/session-overview-button`),
      patientQuestionLabel: getCopyValue(`${sessionReview}/patient-question-label`),
      exercisesLabel: getCopyValue(`${sessionReview}/exercises-label`),
      backToExerciseButton: getCopyValue(`${sessionReview}/back-to-exercise-button`),
      toasterExerciseDifficulty: getCopyValue(`${sessionReview}/exercise-review/toaster-exercise-difficulty`),
      feedbackEmptyState: {
        title: getCopyValue(`${sessionReview}/exercise-review/feedback-empty-state/header`),
        subText: getCopyValue(`${sessionReview}/exercise-review/feedback-empty-state/description`),
      },
      nextPatientOverview: {
        title: getCopyValue(`${sessionReview}/next-patient-s-overview/next-patient-s-overview`),
        tasks: getCopyValue(`${sessionReview}/next-patient-s-overview/tasks`),
        patientDetails: {
          viewPrescription: getCopyValue(`${sessionReview}/next-patient-s-overview/patient-details/view-prescription`),
          uploadPrescription: getCopyValue(
            `${sessionReview}/next-patient-s-overview/patient-details/upload-prescription`,
          ),
          editGoal: getCopyValue(`${sessionReview}/next-patient-s-overview/patient-details/edit-goal`),
          chooseAnotherTherapyPlan: getCopyValue(
            `${sessionReview}/next-patient-s-overview/patient-details/choose-another-therapy-plan`,
          ),
          patientDetails: getCopyValue(`${sessionReview}/next-patient-s-overview/patient-details/patient-details`),
          details: getCopyValue(`${sessionReview}/next-patient-s-overview/patient-details/details`),
          diagnosis: getCopyValue(`${sessionReview}/next-patient-s-overview/patient-details/diagnosis`),
          observations: getCopyValue(`${sessionReview}/next-patient-s-overview/patient-details/observations`),
          limitations: getCopyValue(`${sessionReview}/next-patient-s-overview/patient-details/limitations`),
          therapyPlan: getCopyValue(`${sessionReview}/next-patient-s-overview/patient-details/therapy-plan`),
          started: getCopyValue(`${sessionReview}/next-patient-s-overview/patient-details/started`),
          scheduledEndDate: getCopyValue(`${sessionReview}/next-patient-s-overview/patient-details/scheduled-end-date`),
          daysSinceStart: getCopyValue(`${sessionReview}/next-patient-s-overview/patient-details/days-since-start`),
          goal: getCopyValue(`${sessionReview}/next-patient-s-overview/patient-details/goal`),
          patientAge: getCopyValue(`${sessionReview}/next-patient-s-overview/patient-details/patient-age`),
          diagnosisPlaceholder: getCopyValue(
            `${sessionReview}/next-patient-s-overview/patient-details/diagnosis-placeholder`,
          ),
        },
        progressSummary: {
          title: getCopyValue(`${sessionReview}/next-patient-s-overview/progress-summary/progress-summary`),
          showDetails: getCopyValue(`${sessionReview}/next-patient-s-overview/progress-summary/show-details`),
          sessionCompletion: getCopyValue(
            `${sessionReview}/next-patient-s-overview/progress-summary/session-completion/main-text`,
          ),
          movementQuality: getCopyValue(
            `${sessionReview}/next-patient-s-overview/progress-summary/movement-quality/main-text`,
          ),
          painLevel: getCopyValue(`${sessionReview}/next-patient-s-overview/progress-summary/pain-level/main-text`),
          sessionCompletionTooltip: getCopyValue(
            `${sessionReview}/next-patient-s-overview/progress-summary/session-completion/tooltip-text`,
          ),
          movementQualityTooltip: getCopyValue(
            `${sessionReview}/next-patient-s-overview/progress-summary/movement-quality/tooltip-text`,
          ),
          painLevelTooltip: getCopyValue(
            `${sessionReview}/next-patient-s-overview/progress-summary/pain-level/tooltip-text`,
          ),
        },
      },
      feedback: {
        dropdown: {
          delete: getCopyValue(`${sessionReview}/exercise-review/your-feedback/your-feedback-dropdown-menu/delete`),
          edit: getCopyValue(`${sessionReview}/exercise-review/your-feedback/your-feedback-dropdown-menu/edit`),
        },
        yourFeedbackTitle: getCopyValue(`${sessionReview}/exercise-review/your-feedback/your-feedback`),
        deletePopover: {
          deleteFeedbackTitle: getCopyValue(
            `${sessionReview}/exercise-review/your-feedback/delete-popup-module/delete-feedback`,
          ),
          question: getCopyValue(`${sessionReview}/exercise-review/your-feedback/delete-popup-module/question`),
          cancelButton: getCopyValue(`${sessionReview}/exercise-review/your-feedback/delete-popup-module/cancel`),
          deleteButton: getCopyValue(`${sessionReview}/exercise-review/your-feedback/delete-popup-module/delete`),
        },
      },
      changeDifficulty: {
        title: getCopyValue(`${sessionReview}/exercise-review/change-exercise-difficulty/change-exercise-difficulty`),
        cancelButton: getCopyValue(`${sessionReview}/exercise-review/change-exercise-difficulty/cancel`),
        confirmButton: getCopyValue(
          `${sessionReview}/exercise-review/change-exercise-difficulty/select-difficulty-level`,
        ),
        instructionsAndMaterials: {
          gotItButton: getCopyValue(
            `${sessionReview}/exercise-review/change-exercise-difficulty/instructions-and-materials/got-it`,
          ),
          instructionsLabel: getCopyValue(
            `${sessionReview}/exercise-review/change-exercise-difficulty/instructions-and-materials/instructions-description/title`,
          ),
          materialsLabel: getCopyValue(
            `${sessionReview}/exercise-review/change-exercise-difficulty/instructions-and-materials/materials`,
          ),
        },
        secondsHoldDuration: getCopyValue(
          `${sessionReview}/exercise-review/change-exercise-difficulty/seconds-hold-duration`,
        ),
        setsNumber: getCopyValue(`${sessionReview}/exercise-review/change-exercise-difficulty/sets`),
        repetitionsNumber: getCopyValue(`${sessionReview}/exercise-review/change-exercise-difficulty/repetitions`),
        changeIntensityLabel: getCopyValue(
          `${sessionReview}/exercise-review/change-exercise-difficulty/change-intensity`,
        ),
      },
      sessionReviewSidebar: {
        dismissButton: getCopyValue(`${sessionReview}/exercise-review/session-review-sidebar/dismiss`),
        instructionAndMaterials: getCopyValue(
          `${sessionReview}/exercise-review/session-review-sidebar/instructions-and-materials`,
        ),
        changeDifficultyButton: getCopyValue(
          `${sessionReview}/exercise-review/session-review-sidebar/adjust-difficulty`,
        ),
        difficultyLabel: getCopyValue(`${sessionReview}/exercise-review/session-review-sidebar/difficulty`),
        currentExerciseAndSession: getCopyValue(
          `${sessionReview}/exercise-review/session-review-sidebar/current-exercise-and-session`,
        ),
        exerciseOverviewTitle: getCopyValue(
          `${sessionReview}/exercise-review/session-review-sidebar/exercise-overview-title`,
        ),
        localeTranslated: {
          "en-CH": getCopyValue(`${sessionReview}/exercise-review/session-review-sidebar/en-ch`),
          de: getCopyValue(`${sessionReview}/exercise-review/session-review-sidebar/de`),
          fr: getCopyValue(`${sessionReview}/exercise-review/session-review-sidebar/fr`),
          it: getCopyValue(`${sessionReview}/exercise-review/session-review-sidebar/it`),
        },
      },
      sessionOverview: {
        title: getCopyValue(`${sessionReview}/session-overview/session-overview`),
        sessionNumber: getCopyValue(`${sessionReview}/session-overview/session-number`),
        sessionCompletionTitle: getCopyValue(`${sessionReview}/session-overview/session-completion`),
        painLevel: getCopyValue(`${sessionReview}/session-overview/pain-level`),
        movementQualityTitle: getCopyValue(`${sessionReview}/session-overview/movement-quality`),
        messages: getCopyValue(`${sessionReview}/session-overview/messages`),
        exercises: getCopyValue(`${sessionReview}/session-overview/exercises`),
        sendFeedbackButton: getCopyValue(`${sessionReview}/session-overview/send-feedback-button`),
        forwardToSupportLabel: getCopyValue(`${sessionReview}/session-overview/forward-to-support-label`),
      },
      overallFeedback: {
        exerciseNumber: getCopyValue(`${sessionReview}/exercise-review/overall-feedback/exercise-no`),
        title: getCopyValue(`${sessionReview}/exercise-review/overall-feedback/overall-feedback`),
        patientQuestions: getCopyValue(`${sessionReview}/exercise-review/overall-feedback/patient-question`),
        yourOverallFeedback: getCopyValue(
          `${sessionReview}/exercise-review/overall-feedback/your-overall-feedback/box-title`,
        ),
        inputPlaceholder: getCopyValue(
          `${sessionReview}/exercise-review/overall-feedback/your-overall-feedback/content-example`,
        ),
        noFeedback: {
          title: getCopyValue(`${sessionReview}/exercise-review/overall-feedback/no-feedback/title`),
          subtext: getCopyValue(`${sessionReview}/exercise-review/overall-feedback/no-feedback/sub-text`),
        },
      },
      tasks: {
        seeAllExercises: getCopyValue(`${sessionReview}/tasks/see-all-exercises`),
        giveOverallFeedbackButton: getCopyValue(`${sessionReview}/tasks/give-overall-feedback`),
        estimatedTime: getCopyValue(`${sessionReview}/tasks/est-time-min`),
        movemementQualitty: getCopyValue(`${sessionReview}/tasks/movement-quality`),
        painLevel: getCopyValue(`${sessionReview}/tasks/pain-level`),
        difficulty: getCopyValue(`${sessionReview}/tasks/difficulty`),
        sessionNumber: getCopyValue(`${sessionReview}/tasks/session`),
        weekNumber: getCopyValue(`${sessionReview}/tasks/week`),
        sessionCompletion: getCopyValue(`${sessionReview}/tasks/session-completion`),
        numberExercises: getCopyValue(`${sessionReview}/tasks/number-exercises`),
        exerciseCompletion: getCopyValue(`${sessionReview}/tasks/exercise-completion`),
        exerciseNo: getCopyValue(`${sessionReview}/tasks/session-exercise-no-1/exercise-number`),
      },
      insightsLabel: getCopyValue(`${sessionReview}/insights-label`),
      insights: {
        exercise_painful: getCopyValue(`${sessionReview}/insights/exercise-painful`),
        exercise_difficult: getCopyValue(`${sessionReview}/insights/exercise-difficult`),
        exercise_no_longer_painful: getCopyValue(`${sessionReview}/insights/exercise-no-longer-painful`),
        exercise_no_longer_difficult: getCopyValue(`${sessionReview}/insights/exercise-no-longer-difficult`),
        therapy_ending: getCopyValue(`${sessionReview}/insights/therapy-ending`),
        first_session: getCopyValue(`${sessionReview}/insights/first-session`),
        back_from_break: getCopyValue(`${sessionReview}/insights/back-from-break`),
        movement_quality_drop: getCopyValue(`${sessionReview}/insights/movement-quality-drop`),
        session_cancelled: getCopyValue(`${sessionReview}/insights/session-cancelled`),
        exercise_skipped: getCopyValue(`${sessionReview}/insights/exercise-skipped`),
        exercise_partially_skipped: getCopyValue(`${sessionReview}/insights/exercise-partially-skipped`),
        therapy_halfway: getCopyValue(`${sessionReview}/insights/therapy-halfway`),
        pain_level_increase: getCopyValue(`${sessionReview}/insights/pain-level-increase`),
        pain_level_drop: getCopyValue(`${sessionReview}/insights/pain-level-drop`),
        first_time_mistake: getCopyValue(`${sessionReview}/insights/first-time-mistake`),
        session_goal_streak: getCopyValue(`${sessionReview}/insights/session-goal-streak`),
        session_goal: getCopyValue(`${sessionReview}/insights/session-goal`),
        consistent_low_pain: getCopyValue(`${sessionReview}/insights/consistent-low-pain`),
        consistent_high_movement_quality: getCopyValue(`${sessionReview}/insights/consistent-high-movement-quality`),
        first_time_no_mistakes: getCopyValue(`${sessionReview}/insights/first-time-no-mistakes`),
        movement_quality_improvement: getCopyValue(`${sessionReview}/insights/movement-quality-improvement`),
      },
      mistakesCard: {
        bothSidesTooltip: getCopyValue(`${sessionReview}/exercise-review/both-sides-tooltip`),
        oneSideOnlyTooltip: getCopyValue(`${sessionReview}/exercise-review/one-side-only-tooltip`),
      },
    },

    treatments: {
      title: getCopyValue(`${treatments}/title`),
      tabTherapyPlans: getCopyValue(`${treatments}/tab-therapy-plans`),
      tabPersonalizations: getCopyValue(`${treatments}/tab-personalizations`),
      columnTherapyPlan: getCopyValue(`${treatments}/column-therapy-plan`),
      columnBodyPart: getCopyValue(`${treatments}/column-body-part`),
      columnAvailablePersonalizations: getCopyValue(`${treatments}/column-available-personalizations`),
      columnPersonalizationName: getCopyValue(`${treatments}/column-personalization-name`),
      columnAssociatedTherapyPlan: getCopyValue(`${treatments}/column-associated-therapy-plan`),
      columnAssociatedPatients: getCopyValue(`${treatments}/column-associated-patients`),
      actionsCreateNewPersonalization: getCopyValue(`${treatments}/actions-create-new-personalization`),
      actionsRenamePersonalization: getCopyValue(`${treatments}/actions-rename-personalization`),
      actionsDeletePersonalization: getCopyValue(`${treatments}/actions-delete-personalization`),
      placeholderSearchPersonalization: getCopyValue(`${treatments}/placeholder-search-personalization`),
      placeholderSearchTherapyPlan: getCopyValue(`${treatments}/placeholder-search-therapy-plan`),
      emptyStateNoPersonalizationsTitle: getCopyValue(`${treatments}/empty-state-no-personalizations-title`),
      emptyStateNoPersonalizationsDescription: getCopyValue(
        `${treatments}/empty-state-no-personalizations-description`,
      ),
      backToTreatments: getCopyValue(`${treatments}/back-to-treatments`),
      modalRenamePersonalizationTitle: getCopyValue(`${treatments}/modal-rename-personalization-title`),
      modalRenamePersonalizationName: getCopyValue(`${treatments}/modal-rename-personalization-name`),
      modalRenamePersonalizationNamePlaceholder: getCopyValue(`${treatments}/modal-rename-personalization-placeholder`),
      save: getCopyValue(`${treatments}/save`),
      modalReplacePersonalizationTitle: getCopyValue(`${treatments}/modal-replace-personalization-title`),
      modalReplacePersonalizationDescription: getCopyValue(`${treatments}/modal-replace-personalization-description`),
      cancel: getCopyValue(`${treatments}/cancel`),
      replace: getCopyValue(`${treatments}/replace`),
      modalDeletePersonalizationTitle: getCopyValue(`${treatments}/modal-delete-personalization-title`),
      modalDeletePersonalizationDescription: getCopyValue(`${treatments}/modal-delete-personalization-description`),
      delete: getCopyValue(`${treatments}/delete`),
      toastNewOk: getCopyValue(`${treatments}/toast-new-ok`),
      toastUpdateOk: getCopyValue(`${treatments}/toast-update-ok`),
      toastDeleteOk: getCopyValue(`${treatments}/toast-delete-ok`),
      toastNewError: getCopyValue(`${treatments}/toast-new-error`),
      toastUpdateError: getCopyValue(`${treatments}/toast-update-error`),
      toastDeleteError: getCopyValue(`${treatments}/toast-delete-error`),

      loadPersonalization: getCopyValue(`${treatments}/load-personalization`),
      personalization: getCopyValue(`${treatments}/personalization`),
      personalizationPlaceholder: getCopyValue(`${treatments}/personalization-placeholder`),
      personalizationReplaceAllWarning: getCopyValue(`${treatments}/personalization-replace-all-warning`),
      details: getCopyValue(`${treatments}/details`),
      noPersonalizationTooltip: getCopyValue(`${treatments}/no-personalization-tooltip`),
      toastApplyPersonalizationOk: getCopyValue(`${treatments}/toast-apply-personalization-ok`),
      toastApplyPersonalizationError: getCopyValue(`${treatments}/toast-apply-personalization-error`),
    },

    patientManagement: {
      phaseUpdated: getCopyValue(`${patientManagement}/phase-updated`),
      streakTooltip: getCopyValue(`${patientManagement}/streak-tooltip`),
      cantWorkOnTask: getCopyValue(`${patientManagement}/cant-work-on-task`),
      patientUnavailable: getCopyValue(`${patientManagement}/patient-unavailable`),
      tasksFilterLabel: getCopyValue(`${patientManagement}/tasks-filter-label`),
      completedTasksFilter: getCopyValue(`${patientManagement}/completed-tasks-filter`),
      openTasksFilter: getCopyValue(`${patientManagement}/open-tasks-filter`),
      exerciseInsights: {
        title: getCopyValue(`${patientManagement}/exercise-insights/title`),
        searchPlaceholder: getCopyValue(`${patientManagement}/exercise-insights/search-placeholder`),
        filter: getCopyValue(`${patientManagement}/exercise-insights/filter`),
        exerciseInstances: getCopyValue(`${patientManagement}/exercise-insights/exercise-instances`),
        difficultInstances: getCopyValue(`${patientManagement}/exercise-insights/difficult-instances`),
        painfulInstances: getCopyValue(`${patientManagement}/exercise-insights/painful-instances`),
        movementQuality: getCopyValue(`${patientManagement}/exercise-insights/movement-quality`),
        painLevel: getCopyValue(`${patientManagement}/exercise-insights/pain-level`),
        sessionCompletion: getCopyValue(`${patientManagement}/exercise-insights/session-completion`),
        exerciseName: getCopyValue(`${patientManagement}/exercise-insights/exercise-name`),
        trendTooltip: getCopyValue(`${patientManagement}/exercise-insights/trend-tooltip`),
        lastInstanceOn: getCopyValue(`${patientManagement}/exercise-insights/last-instance-on`),
        recentTag: getCopyValue(`${patientManagement}/exercise-insights/recent-tag`),
        olderTag: getCopyValue(`${patientManagement}/exercise-insights/older`),
        sortLabelTotalInstances: getCopyValue(`${patientManagement}/exercise-insights/exercise-instances`),
        sortLabelMarkedPainful: getCopyValue(`${patientManagement}/exercise-insights/sort-label-marked-painful`),
        sortLabelMarkedDifficult: getCopyValue(`${patientManagement}/exercise-insights/sort-label-marked-difficult`),
        filterLabelMarkedPainful: getCopyValue(`${patientManagement}/exercise-insights/filter-label-marked-painful`),
        filterLabelMarkedDifficult: getCopyValue(
          `${patientManagement}/exercise-insights/filter-label-marked-difficult`,
        ),
        filterLabelExercisesCategory: getCopyValue(
          `${patientManagement}/exercise-insights/filter-label-exercises-category`,
        ),
      },
    },

    patient: {
      detailsPage: {
        editGoalModal: {
          editGoalButton: getCopyValue(`${patientManagement}/patient-detail-page/patient-details-section/edit-goal`),
          therapyGoalText: getCopyValue(`${patientManagement}/patient-detail-page/edit-goal-modal/therapy-goal`),
          editGoalTitle: getCopyValue(`${patientManagement}/patient-detail-page/edit-goal-modal/title`),
          cancelButton: getCopyValue(`${patientManagement}/patient-detail-page/edit-goal-modal/cancel`),
          setGoalButton: getCopyValue(`${patientManagement}/patient-detail-page/edit-goal-modal/set-goal`),
        },
        outcomes: {
          headline: getCopyValue(`${patientManagement}/patient-detail-page/outcomes-headline`),
          totalSessionsTitle: getCopyValue(`${patientManagement}/patient-detail-page/total-sessions-title`),
          noSessions: getCopyValue(`${patientManagement}/patient-detail-page/no-sessions`),
          weeklyAverage: getCopyValue(`${patientManagement}/patient-detail-page/weekly-average`),
          totalTrainingTimeTitle: getCopyValue(`${patientManagement}/patient-detail-page/total-training-time-title`),
          latestPainLevelRatingTitle: getCopyValue(
            `${patientManagement}/patient-detail-page/latest-pain-level-rating-title`,
          ),
          baseline: getCopyValue(`${patientManagement}/patient-detail-page/baseline`),
          numberOutOf10: getCopyValue(`${patientManagement}/patient-detail-page/number-out-of-10`),
        },
        tasksHeadline: getCopyValue(`${patientManagement}/patient-detail-page/tasks-headline`),
        transferPatientButton: getCopyValue(`${patientManagement}/patient-detail-page/transfer-patient`),
        disconnectPatientButton: getCopyValue(`${patientManagement}/patient-detail-page/delete-patient`),
        patientAge: getCopyValue(`${patientManagement}/patient-detail-page/patient-age`),
        patientLanguage: getCopyValue(`${patientManagement}/patient-detail-page/patient-language`),
        patientNameTherapyPlan: getCopyValue(
          `${patientManagement}/patient-detail-page/therapy-plan-modal/patient-name-therapy-plan`,
        ),
        readTooltip: getCopyValue(`${patientManagement}/patient-detail-page/read-tooltip`),
        deliveredTooltip: getCopyValue(`${patientManagement}/patient-detail-page/delivered-tooltip`),
        painLevelTrendTooltip: getCopyValue(`${patientManagement}/patient-detail-page/pain-level-trend-tooltip`),
        oneSideOnlyTooltip: getCopyValue(`${patientManagement}/patient-detail-page/one-side-only-tooltip`),
      },
      deletePatientModal: {
        deletePatientText: getCopyValue(`${patientManagement}/delete-patient/delete-patient`),
        question: getCopyValue(`${patientManagement}/delete-patient/question`),
        cancelButton: getCopyValue(`${patientManagement}/delete-patient/cancel`),
        deleteButton: getCopyValue(`${patientManagement}/delete-patient/delete`),
        successToast: getCopyValue(`${patientManagement}/delete-patient/success-toast`),
        errorToast: getCopyValue(`${patientManagement}/delete-patient/error-toast`),
        disclaimer: getCopyValue(`${patientManagement}/delete-patient/disclaimer`),
      },
      table: {
        filter: getCopyValue(`${patientManagement}/filter`),
        list: getCopyValue(`${patientManagement}/list`),
        searchBarPlaceholder: getCopyValue(`${patientManagement}/tablesearchbar/content-example`),
        tabs: {
          all: getCopyValue(`${patientManagement}/tabs/all`),
          active: getCopyValue(`${patientManagement}/tabs/active`),
          inactive: getCopyValue(`${patientManagement}/tabs/inactive`),
          onboarding: getCopyValue(`${patientManagement}/tabs/onboarding`),
          ending: getCopyValue(`${patientManagement}/tabs/ending`),
          completed: getCopyValue(`${patientManagement}/tabs/completed`),
        },
        days: getCopyValue(`${patientManagement}/days`),
        noActivityYet: getCopyValue(`${patientManagement}/no-activity-yet`),
        expired: getCopyValue(`${patientManagement}/expired`),
        numSessionsInNumDays: getCopyValue(`${patientManagement}/num-sessions-in-num-days`),
        lastNumberOfDaysAgo: getCopyValue(`${patientManagement}/last-number-of-days-ago`),
        invitedNumberOfDaysAgo: getCopyValue(`${patientManagement}/invited-number-of-days-ago`),
        reminderSentDaysAgo: getCopyValue(`${patientManagement}/reminder-sent-days-ago`),
        sendReminder: getCopyValue(`${patientManagement}/send-reminder`),
        sendReminderSuccessMessage: getCopyValue(`${patientManagement}/send-reminder-success-message`),
        sendReminderTooltipContent: getCopyValue(`${patientManagement}/send-reminder-tooltip-content`),
        extendTherapy: getCopyValue(`${patientManagement}/extend-therapy`),
        extendTherapyModal: {
          title: getCopyValue(`${patientManagement}/extend-therapy-modal/title`),
          submitButton: getCopyValue(`${patientManagement}/extend-therapy-modal/submit-button`),
          successToastMessage: getCopyValue(`${patientManagement}/extend-therapy-modal/success-toast-message`),
          errorToastMessage: getCopyValue(`${patientManagement}/extend-therapy-modal/error-toast-message`),
          insuranceInfo: getCopyValue(`${patientManagement}/extend-therapy-modal/insurance-info`),
          selfPayerInfo: getCopyValue(`${patientManagement}/extend-therapy-modal/self-payer-info`),
          alreadyExtendedTooltip: getCopyValue(`${patientManagement}/extend-therapy-modal/already-extended-tooltip`),
          prescriptionMissingTooltip: getCopyValue(
            `${patientManagement}/extend-therapy-modal/prescription-missing-tooltip`,
          ),
          dropPrescriptionIfAvailable: getCopyValue(
            `${patientManagement}/extend-therapy-modal/drop-prescription-if-available`,
          ),
        },
        resendInvitation: getCopyValue(`${patientManagement}/resend-invite`),
        resendInviteSuccessMessage: getCopyValue(`${patientManagement}/resend-invite-success-message`),
        resendInviteErrorMessage: getCopyValue(`${patientManagement}/resend-invite-error-message`),
        sendReminderErrorMessage: getCopyValue(`${patientManagement}/send-reminder-error-message`),
        revokeInvitationModal: {
          title: getCopyValue(`${patientManagement}/revoke-invitation-modal/title`),
          description: getCopyValue(`${patientManagement}/revoke-invitation-modal/description`),
          cancelButton: getCopyValue(`${patientManagement}/revoke-invitation-modal/cancel-button`),
          submitButton: getCopyValue(`${patientManagement}/revoke-invitation-modal/submit-button`),
          successMessage: getCopyValue(`${patientManagement}/revoke-invitation-modal/success-message`),
          errorMessage: getCopyValue(`${patientManagement}/revoke-invitation-modal/error-message`),
        },
        revokeInvitation: getCopyValue(`${patientManagement}/revoke-invitation`),
      },
      advancePatientConfirmationModal: {
        title: getCopyValue(`${patientManagement}/patient-detail-page/advance-patient-confirmation-modal/title`),
        subtext: getCopyValue(`${patientManagement}/patient-detail-page/advance-patient-confirmation-modal/sub-text`),
      },
      progressSummary: {
        title: getCopyValue(`${patientManagement}/patient-detail-page/progress-summary-section/progress-summary`),
        sessionCompletion: getCopyValue(
          `${patientManagement}/patient-detail-page/progress-summary-section/session-completion/main-text`,
        ),
        movementQuality: getCopyValue(
          `${patientManagement}/patient-detail-page/progress-summary-section/movement-quality/main-text`,
        ),
        painLevel: getCopyValue(
          `${patientManagement}/patient-detail-page/progress-summary-section/pain-level/main-text`,
        ),
      },
      chooseTherapyPlanModal: {
        cancelButton: getCopyValue(`${patientManagement}/patient-detail-page/choose-therapy-plan-modal/cancel`),
        selectButton: getCopyValue(`${patientManagement}/patient-detail-page/choose-therapy-plan-modal/select`),
      },
      therapyPhases: {
        nowLabel: getCopyValue(`${patientManagement}/patient-detail-page/phases-element/now`),
        activationScheduledLabel: getCopyValue(
          `${patientManagement}/patient-detail-page/phases-element/activation-scheduled`,
        ),
        sessionTime: getCopyValue(`${patientManagement}/patient-detail-page/phases-element/session-time`),
        weekLabel: getCopyValue(`${patientManagement}/patient-detail-page/phases-element/week`),
        title: getCopyValue(`${patientManagement}/patient-detail-page/phases-element/phases`),
        viewTherapyPlanLink: getCopyValue(`${patientManagement}/patient-detail-page/phases-element/view-therapy-plan`),
        warning: getCopyValue(`${patientManagement}/patient-detail-page/phases-element/warning`),
        activatePhaseButton: getCopyValue(`${patientManagement}/patient-detail-page/phases-element/activate-phase`),
        reactivate: getCopyValue(`${patientManagement}/patient-detail-page/phases-element/reactivate`),
        cancelActivation: getCopyValue(`${patientManagement}/patient-detail-page/phases-element/cancel-activation`),
        sessionsInPhase: getCopyValue(`${patientManagement}/patient-detail-page/phases-element/sessions-in-phase`),
        phaseNumber: getCopyValue(`${patientManagement}/patient-detail-page/phases-element/phase-number`),
      },
      backToPatients: getCopyValue(`${patientManagement}/patient-detail-page/back`),
      backToAdmin: getCopyValue(`${patientManagement}/patient-detail-page/back-to-admin`),

      emptyState: {
        titleAllTab: getCopyValue(`${patientManagement}/empty-state/all-tab/title`),
        descriptionAllTab: getCopyValue(`${patientManagement}/empty-state/all-tab/sub-text`),
        titleActiveTab: getCopyValue(`${patientManagement}/empty-state/active-tab/title`),
        descriptionActiveTab: getCopyValue(`${patientManagement}/empty-state/active-tab/sub-text`),
        titleInactiveTab: getCopyValue(`${patientManagement}/empty-state/inactive-tab/title`),
        descriptionInactiveTab: getCopyValue(`${patientManagement}/empty-state/inactive-tab/sub-text`),
        titleOnboardingTab: getCopyValue(`${patientManagement}/empty-state/onboarding-tab/title`),
        descriptionOnboardingTab: getCopyValue(`${patientManagement}/empty-state/onboarding-tab/sub-text`),
        titleEndingTab: getCopyValue(`${patientManagement}/empty-state/ending-tab/title`),
        descriptionEndingTab: getCopyValue(`${patientManagement}/empty-state/ending-tab/sub-text`),
        titleCompletedTab: getCopyValue(`${patientManagement}/empty-state/completed-tab/title`),
        descriptionCompletedTab: getCopyValue(`${patientManagement}/empty-state/completed-tab/sub-text`),
      },

      listLabels: {
        patient: getCopyValue(`${patientManagement}/list-labels/patient`),
        therapyPhase: getCopyValue(`${patientManagement}/list-labels/therapy-phase`),
        therapyPlan: getCopyValue(`${patientManagement}/list-labels/therapy-plan`),
        therapyProgress: getCopyValue(`${patientManagement}/list-labels/therapy-progress`),
        activity: getCopyValue(`${patientManagement}/list-labels/activity`),
      },
      patients: getCopyValue(`${patientManagement}/patients`),
    },
    settings: {
      myAccount: {
        heading: getCopyValue(`${settings}/my-account/heading`),
        changePassword: getCopyValue(`${settings}/my-account/change-password`),
        password: getCopyValue(`${settings}/my-account/password/title`),
        checkEmailInstruction: getCopyValue(`${settings}/my-account/change-password-module/check-email-instruction`),
        setPasswordInstruction: getCopyValue(`${settings}/my-account/change-password-module/set-password-instruction`),
        closeAccount: getCopyValue(`${settings}/my-account/close-account-module/close-account`),
        closeAccountInstruction: getCopyValue(`${settings}/my-account/close-account-module/instruction`),
        closeAccountClickHere: getCopyValue(`${settings}/my-account/close-account-module/click-here`),
        closeAccountActionURL: getCopyValue(`${settings}/my-account/close-account-action-url`),
        saveButton: getCopyValue(`${settings}/my-account/save`),
        contactEmail: getCopyValue(`${settings}/my-account/email`),
        bio: getCopyValue(`portal/profile/bio`),
        bioPlaceholder: getCopyValue(`portal/profile/bio-placeholder`),
        lastNameLabel: getCopyValue(`${settings}/my-account/last-name`),
        firstNameLabel: getCopyValue(`${settings}/my-account/first-name`),
        profileDetailsTitle: getCopyValue(`${settings}/my-account/profile-details/title`),
        profileDetailsDescription: getCopyValue(`${settings}/my-account/profile-details/sub-text`),
        yourUniqueMedicalIdentifer: getCopyValue(`${settings}/my-account/your-unique-medical-identifier`),
        tooltipContent: getCopyValue(`${settings}/udi-and-ce-mark/udi-tooltip`),
      },
      navigation: {
        settingsTitle: getCopyValue(`${settings}/account-settings-page-navigation/settings`),
        language: getCopyValue(`${settings}/account-settings-page-navigation/language`),
        myAccount: getCopyValue(`${settings}/account-settings-page-navigation/my-account`),
        notification: getCopyValue(`${settings}/account-settings-page-navigation/notifications`),
        termsAndConditions: getCopyValue(`${settings}/account-settings-page-navigation/terms-and-conditions`),
        instructionsForUse: getCopyValue(`${settings}/account-settings-page-navigation/instructions-for-use`),
        dataPolicy: getCopyValue(`${settings}/account-settings-page-navigation/data-policy`),
        releaseNotes: getCopyValue(`${settings}/account-settings-page-navigation/release-notes`),
      },
      language: {
        title: getCopyValue(`${settings}/language/heading`),
        description: getCopyValue(`${settings}/language/select-language`),
      },
      notifications: {
        heading: getCopyValue(`${settings}/notifications/heading`),
        email: {
          title: getCopyValue(`${settings}/notifications/email-notifications/title`),
          subtitle: getCopyValue(`${settings}/notifications/email-notifications/sub-text`),
        },
        types: {
          accountManagement: getCopyValue(`${settings}/notifications/notifications/account-management`),
          patientUpdates: getCopyValue(`${settings}/notifications/notifications/patient-updates`),
          reminders: getCopyValue(`${settings}/notifications/notifications/reminders`),
        },
      },
      succesfulUpdateText: getCopyValue(`${settings}/successful-update-text`),
      toasters: {
        settingsUpdatedSuccess: getCopyValue(`${settings}/successful-update-text`),
      },
    },
  };
};

export { mapToCopyFilePortal };
